const $ = require('jquery');

// JS for the Homepage HOPE Heroes

// variables first
var hopeHeroWrapper = $('#hope-hero-wrapper');
var hopeContainer = $('.hope-container');
var hope = $('.hope');
var h2top = $('.today');
var h2bottom = $('.tomorrow');
var words = $('.hope-container span.word');

// collection of the various heroes
var hopeImagesArray = ['hope-hero-01.png', 'hope-hero-02.png', 'hope-hero-03.png'];

// switch out the src attribute on page loads
$('#hope-image').attr('src', 'themes/custom/altos_child/images/' + hopeImagesArray[Math.floor(Math.random() * hopeImagesArray.length)]);
//$('#hope-image').attr('src', 'themes/custom/altos_child/images/hope-hero-epilepsy-awareness-month.png');

// animate in each piece
hope.css({'opacity' : 1, 'transform' : 'translate3d(0, 0, 0)'});
words.css({'opacity' : 1, 'transform' : 'translate3d(0, 0, 0)'});





//------------------------------------------------
// Mobile Full-Height Behaviors
//------------------------------------------------

// Need to automatically calculate the height of the header and inject it to inline style.
function setHopeHeight() {

  if (window.innerWidth < 1000) {
    var navBarHeight = $('.site-header').outerHeight();
    $('#hope-hero-wrapper').css('height', $(window).height() - navBarHeight + 'px');
  }

}

// Run function immediately and again as window resizes.
setHopeHeight();
$(window).resize(setHopeHeight);


//------------------------------------------------
// Add link and scrolling to HOPE Hero down icon
//------------------------------------------------
$('.hope-down-arrow').on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: $('.site-header').outerHeight() + $('#hope-hero-wrapper').outerHeight() }, 1200);
});
